import React, { useState } from "react";
import ViewTableIndex from "../../../components/View/ViewTableIndex";
import { useStandard } from "../../../context/StandardContext";
import { Link, useParams } from "react-router-dom";
import UseGetData from "../../../hooks/useFetchData";
import ViewTaskTableIndex from "../../../components/View/ViewTaskTable";
import useGetStatusData from "../../../hooks/useGetStatusData";
import NuDateFormat from "../../../utils/NuDate";
import useDashboardStatus from "../../../hooks/useDashboardStatus";
import ViewMore from "./viewMore";
import CreateOrEdit from "./form";
import { useFormik } from "formik";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { CloseIcon } from "../../../assets/icons";
import FormikSelectTwo from "../../../utils/Select";
import CommomApproval from "../../../utils/CommomApproval";
import useGetStandardDetail from "../../../hooks/useGetStandardDetail";
import { GetAccess } from "../../../utils/RolesandAccess";

function TaskManagementIndex() {
  const [showFilter, setShowFilter] = useState(false);
  const [createNew, setCreateNew] = useState({
    status: "",
    start_completion_date: "",
    end_completion_date: "",
    start_reminder_date: "",
    end_reminder_date: "",
  });

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validateOnChange: false,
      validateOnBlur: false,
      onSubmit: (value, { resetForm }) => {
        console.log();
        setCreateNew(value);
        setFilter(true)
        setTimeout(() => {
          setShowFilter(false);
        }, 600);
        getData()
      },
    });
  const ModelId = 10;
  const { standardName } = useStandard();
  const { stdId } = useParams();
  const { standardDetailName, standardStartDate, standardEndDate } =
  useGetStandardDetail({ id: stdId });
  const [showMyModal, setShowMyModal] = useState(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [dataCount, setDataCount] = useState(20);
  const { statusValue } = useGetStatusData({ value: ModelId });
  const [searchQuery,setSearchQuery] =useState("")
  const [search, setSearch] = useState(false);
  const [filter, setFilter] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const handleApprovalOnClose = () => setShowApprovalModal(false);
  const { data, totalCount, getData, isLoading } = UseGetData({
    url:
      search == true
        ? `/search/taskSearch/${stdId}/${searchQuery}`
        : filter == true
        ? `/search/taskFilter/${stdId}`
        : `/Calender-Management/current_task/${stdId}`,
    page: pageIndex,
    pageCount: dataCount,
    param: filter == true ? createNew:{}
  });

  const {
    completePercentage,
    getData: getDashboardData,
    isReveiw,
  } = useDashboardStatus({
    url: `/DashBoard/standard/${stdId}/calender-management/`,
  });

  function SearchData(e) {
    e.preventDefault();
    if (searchQuery !== "") {
      setSearch(true)
      getData()
    } else {
      setSearch(false)
      getData()
    }
  }
function handleChange(e){
  console.log(e.target.value);
  if(e.target.value !==""){
    setSearchQuery(e.target.value)
  }else{
    setSearch(false)
  }
  
}


function handleFilterOnClose() {
  setShowFilter(false);
  formik.resetForm();
  setCreateNew({
    status: "",
    start_completion_date: "",
    end_completion_date: "",
    start_reminder_date: "",
    end_reminder_date: "",
  })
  setFilter(false)
  getData()
}

const handleOnClose = () =>  {setShowMyModal(false);}


  return (
    <>
      <ViewTaskTableIndex
        label="Task Management"
        menu="Information"
        standardName={standardName}
        total={totalCount}
        setDataCount={setDataCount}
        dataCount={dataCount}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        setOpenForm={setShowMyModal}
        Access="information_create"
        header={header}
        isLoading={isLoading}
        setSearchQuery={handleChange}
        SearchData={SearchData}
        setShowFilterModal={setShowFilter}
        isFilter={filter}
        clearFilter={handleFilterOnClose}
        hasApprove={true}
        ReviewStatus={isReveiw}
        ReviewFunction={() => setShowApprovalModal(true)}
        OverAllPercentage={completePercentage}
      >
        <>
          {data &&
            data?.map((i) => {
              return (
                <tr
                  className="odd:bg-tableodd even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1"
                  key={i}
                >
                  <td className="px-2 py-2  text-gray-900 whitespace-nowrap text-center w-[5%] capitalize">
                    {i.serial_number || "#"}
                  </td>
                  <td className="px-2 py-2  text-gray-900  w-[15%] break-words capitalize text-left">
                    {i?.task_id == 1
                      ? "Implementation Checklist"
                      : i?.task_id == 2
                      ? "Internal Audit"
                      : i?.task_id == 3
                      ? "Maintenance"
                      : i?.task_id == 4
                      ? "Master List of Documents"
                      : i?.task_id == 18
                      ? "CISO / MRM Meeting MoM"
                      : i?.task_id == 6
                      ? "Audit Schedule"
                      : i?.task_id == 12
                      ? "Security Incident"
                      : i?.task_id == 16
                      ? "Training Calendar"
                      :"-"}
                  </td>
                  <td className="px-2  py-2 text-gray-900 truncate  text-center w-[22%] capitalize">
                    {i.title || "_"}
                  </td>
                  <td className="px-2 py-2 text-gray-900   text-center w-[21%] capitalize">
                    {i.comment || "-"}
                  </td>
                  <td className="px-2 py-2 text-gray-900 whitespace-nowrap text-center w-[12%] capitalize">
                    {(i.completion_date !== "None" && (
                      <Link
                        to={`/standard/${stdId}/information/calendar-management`}
                      >
                        <NuDateFormat
                          value={i.completion_date}
                          format="DD-MMM-YYYY"
                        />
                      </Link>
                    )) ||
                      "-"}
                  </td>
                  <td className="px-2 py-2 text-gray-900  whitespace-nowrap text-center w-[12%] capitalize">
                    {(i.reminder_date !== "None" && (
                      <Link
                        to={`/standard/${stdId}/information/calendar-management`}
                      >
                        <NuDateFormat
                          value={i.reminder_date}
                          format="DD-MMM-YYYY"
                        />
                      </Link>
                    )) ||
                      "-"}
                  </td>
                  <td className="px-2 py-2 text-gray-900 capitalize whitespace-nowrap text-center w-[10%]">
                    {i.status || "-"}
                  </td>
                  <td className=" w-[3%] flex justify-center items-center">
                    <ViewMore
                      data={i}
                      satusData={statusValue}
                      fetcher={getData}
                      id={stdId}
                      otherFunction={getDashboardData}
                    />
                  </td>
                </tr>
              );
            })}
        </>
      </ViewTaskTableIndex>

      <CreateOrEdit
        visible={showMyModal}
        onClose={handleOnClose}
        refreshData={getData}
        satusData={statusValue}
        id={stdId}
        otherFunction={getDashboardData}
      />

{showFilter && (
        <>
          <div
            id="modal"
            className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
    flex justify-center items-center "
          >
            <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
              <div className="flex items-start justify-between px-5 py-2  rounded-t">
                <h3 className="text-base 2xl:text-lg font-semibold">Filter</h3>
                <span
                  className="h-6 w-6 text-2xl block cursor-pointer"
                  onClick={handleFilterOnClose}
                >
                  <CloseIcon />
                </span>
              </div>
              <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
                <div className=" w-full  max-h-[70vh] overflow-y-auto relative px-6 flex flex-wrap justify-between">
                  <FormikSelectTwo
                    formik={formik}
                    name="status"
                    label="Status"
                    width="w-full"
                    placeholder="Select Status"
                    Options={statusValue}
                    zindex={12}
                  />
                </div>
                <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                  <CancelButton onClose={handleOnClose} />
                  <SubmitButton />
                </div>
              </form>
            </div>
          </div>
        </>
      )}

      {GetAccess("review_and_approve") && (
        <CommomApproval
        visible={showApprovalModal}
        onClose={handleApprovalOnClose}
        refreshData={getData}
        moduleId={ModelId}
        id={stdId}
        moduleName="Task Management"
        standardName={standardDetailName}
        getCompletion={getDashboardData}
      />
      )}

    </>
  );
}

export default TaskManagementIndex;

const header = [
  {
    headone: <span>Sl&nbsp;No.</span>,
    width: "w-[5%]",
  },
  {
    headone: "Task",
    width: "w-[15%]",
  },
  {
    headone: "Title",
    width: "w-[22%]",
  },
  {
    headone: "Comments",
    width: "w-[21%]",
  },
  {
    headone: <span>Completion&nbsp;Date</span>,
    width: "w-[12%]",
  },
  {
    headone: <span>Reminder&nbsp;Date</span>,
    width: "w-[12%]",
  },
  {
    headone: "Status",
    width: "w-[10%]",
  },
  {
    headone: " ",
    width: "w-[3%]",
  },
];
